export const PICKUP_HTML_ID = 'pickup'
export const MAIN_DATA_HTML_ID = 'main-data'
export const ADDITIONAL_DATA_HTML_ID = 'additional-data'
export const OTHER_DATA_HTML_ID = 'other-data'
export const CREDIT_RESULT_HTML_ID = 'credit-result'
